import './alert.css';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import alertClose from './assets/icon-title-alert-close.svg';
import alertIcon from './assets/icon-title-alert.svg';

const showMessage = message => {
  if (message) {
    if (message.body.status) return message.body.status;
    if (message.body.message) return message.body.message;
    if (message.body.status) return message.body.status;
    if (message.data) {
      console.log('message.data');
      console.log(message.body.msg);
      //return `below files are failed to translate:${message.data}`;
      return `${message.body.msg}`;
    }
  }

  return 'General Server Error';
};

const AlertTranslation = ({ title, body, message, isOpen, onClose }) => {
  console.log(message);

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Alert"
      className="modal"
      overlayClassName="overlay"
    >
      <div className="alert">
        <div className="alert-header">
          <img alt="" src={alertIcon} />
          {title}
        </div>
        <div className="alert-content">
          <p>
            <FormattedMessage
              id="not-found.panel.paragraph.2"
              defaultMessage="Exceptions returned from server:"
            />
          </p>
          <p>{showMessage(message)}</p>
        </div>
        <button className="button" onClick={onClose}>
          OK
        </button>
        <div className="close" onClick={onClose}>
          <img alt="" src={alertClose} />
        </div>
      </div>
    </Modal>
  );
};
// const closeModal = () => {
//   localStorage.clear();
//   sessionStorage.clear();
//   document.location.pathname = '/en-CA/login';
// };

AlertTranslation.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  body: PropTypes.string,
  message: PropTypes.object
};

export default AlertTranslation;



// WEBPACK FOOTER //
// ./src/components/elements/AlertTranslation/index.js